<template>
  <Modal id="PayModeDetail" width="60%" :visible="visible" @cancel="visible = !visible" @ok="visible = !visible" :title="$t('payMode.name.detailTitle')" :zIndex="9999999900">
    <Descriptions >
      <DescriptionsItem :label="$t('payMode.field.id_pay_mod')">{{data.idPayMod}}</DescriptionsItem>
      <DescriptionsItem :label="$t('payMode.field.pay_mode')">{{data.payMode}}</DescriptionsItem>
      <DescriptionsItem :label="$t('payMode.field.quantity')">{{data.quantity}}</DescriptionsItem>
      <DescriptionsItem :label="$t('payMode.field.create_date')">{{data.createDate}}</DescriptionsItem>
      <DescriptionsItem :label="$t('payMode.field.status')">{{selectList.statusList.find(item=>item.value===data.status).label}}</DescriptionsItem>
  </Descriptions>
  </Modal>
</template>

<script>
import { Modal, Descriptions,DescriptionsItem } from "ant-design-vue";
import { LoadingOutlined, PlusOutlined } from "@ant-design/icons-vue";

export default {
  name: "PayModeDetail",
  components: {
    Modal,
    LoadingOutlined,
    PlusOutlined,
    Descriptions,
    DescriptionsItem,
  },
  data() {
    return {
      selectList:{
        statusList: [{value: 0,label: 'Off'},{value:1,label: 'On'}],
      },
      data: {
      },
      visible: false,
    };
  },
  computed: {
  },
  methods: {
    async detailShow(obj) {
      this.data = JSON.parse(JSON.stringify(obj));
      this.visible = true;
    },
  },
}
</script>

<style lang="less">
</style>